import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns from 'UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { ITableColumnsType } from 'uikit/tables/default'

export const getYears = (yearsBack: number): number[] => {
  const currentYear = new Date().getFullYear()
  const yearsArray: number[] = []

  for (let i = 0; i <= yearsBack; i++) {
    const year = currentYear - i
    if (year !== 2019) {
      yearsArray.push(year)
    }
  }

  return yearsArray.reverse()
}

export const fatcaColumns: ITableColumnsType<any> = [
  columns[COLUMNS_IDS.profileNames],
  columns[COLUMNS_IDS.verifiedName],
  columns[COLUMNS_IDS.tin],
  columns[COLUMNS_IDS.reportStatus],
  { ...columns[COLUMNS_IDS.unreportedRevenue], title: 'Total unreported earnings', minWidth: 240 },
  columns[COLUMNS_IDS.attributedRevenue],
  { ...columns[COLUMNS_IDS.ecommerceDocumentedRevenue], title: 'Total documented earnings', minWidth: 240 },
  columns[COLUMNS_IDS.summary],
  columns[COLUMNS_IDS.controllingEntities],
  columns[COLUMNS_IDS.addresses],
  columns[COLUMNS_IDS.caseId],
  { ...columns[COLUMNS_IDS.locations], title: 'Docrefidar' },
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  fatcaColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
